import './MagnifierAnimation.css';

interface MagnifierAnimationProps {
  message?: string;
  subMessage?: string;
  /**
   * Optional photo URL to show behind the animation.
   * When provided, the magnifier + overlays sit on top of the real garden photo.
   */
  imageUrl?: string | null;
}

export default function MagnifierAnimation({
  message = 'Analyzing your garden...',
  subMessage = 'Detecting features and understanding your space',
  imageUrl,
}: MagnifierAnimationProps) {
  return (
    <div className="magnifier-analysis-container">
      <div className="magnifier-scene">
        {/* Garden photo representation with clearer structure */}
        <div
          className="garden-photo-preview"
          style={
            imageUrl
              ? {
                  backgroundImage: `url(${imageUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }
              : undefined
          }
        >
          {/* Photo frame */}
          <div className="photo-frame" />

          {/* Grid pattern to represent photo analysis */}
          <div className="photo-grid">
            <div className="grid-line horizontal line-1" />
            <div className="grid-line horizontal line-2" />
            <div className="grid-line vertical line-3" />
            <div className="grid-line vertical line-4" />
          </div>

          {/* Feature detection highlights - pulse only, no labels */}
          <div className="detection-highlight highlight-1">
            <div className="highlight-pulse" />
          </div>
          <div className="detection-highlight highlight-2">
            <div className="highlight-pulse" />
          </div>
          <div className="detection-highlight highlight-3">
            <div className="highlight-pulse" />
          </div>

          {/* Analysis overlay */}
          <div className="analysis-overlay" />
        </div>

        {/* Magnifying glass - lens + external handle so it doesn't get clipped */}
        <div className="magnifier-glass">
          <div className="magnifier-lens">
            <div className="magnifier-reflection" />
            <div className="magnifier-crosshair" />
          </div>
          <div className="magnifier-handle" />
          <div className="magnifier-glow" />
        </div>
      </div>

      <div className="magnifier-text">
        <h6 className="mb-2">{message}</h6>
        <p className="text-muted small mb-0">{subMessage}</p>
      </div>

      {/* Scanning indicator */}
      <div className="scanning-indicator">
        <div className="scan-line" />
      </div>
    </div>
  );
}

